<template>
  <div class="content">
    <div class="left-sidebar" id="left-sidebar">
      <el-menu default-active="1" class="el-menu-vertical-demo">
        <el-submenu v-for="item in items" :index="item.index" :key="item.index">
          <template slot="title">
            <i class="el-icon-menu"></i>
            {{ item.name }}
          </template>
          <template v-for="option in item.options">
            <el-submenu
              v-if="option.children && option.children.length"
              :index="option.index"
              :key="option.index"
            >
              <template slot="title">{{ option.name }}</template>
              <el-menu-item
                v-for="child in option.children"
                :index="child.index"
                :key="child.index"
              >
                <router-link :to="child.link">{{ child.name }}</router-link>
              </el-menu-item>
            </el-submenu>
            <el-menu-item v-else :index="option.index" :key="option.index">
              <router-link :to="option.link">{{ option.name }}</router-link>
            </el-menu-item>
          </template>
        </el-submenu>
      </el-menu>
    </div>
    <keep-alive :max="1">
      <router-view
        v-if="$route.meta.keepAlive"
        class="right-iframe"
        id="right-iframe"
      ></router-view>
    </keep-alive>
    <router-view
      v-if="!$route.meta.keepAlive"
      class="right-iframe"
      id="right-iframe"
    ></router-view>
  </div>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          name: "文章",
          index: "1",
          options: [
            {
              index: "1-1",
              link: "/yunying/article/articleManage",
              name: "内容管理",
            },
            {
              index: "1-2",
              link: "/yunying/article/addPicture",
              name: "上传内容图片",
            },
          ],
        },
        {
          name: "社区管理",
          index: "2",
          options: [
            {
              index: "2-1",
              name: "用户管理",
              children: [
                {
                  index: "2-1-1",
                  link: "/yunying/community/user/list",
                  name: "用户列表",
                },
                {
                  index: "2-1-2",
                  link: "/yunying/user/burner/account",
                  name: "马甲号管理",
                },
              ],
            },
            {
              index: "2-2",
              link: "/yunying/dynamic/dynamicManage",
              name: "动态管理",
            },
            {
              index: "2-5",
              link: "/yunying/dynamic/reportManage",
              name: "举报管理",
            },
            {
              index: "2-3",
              link: "/yunying/comment/commentManage",
              name: "评论管理",
            },
            {
              index: "2-4",
              link: "/yunying/topic/topicManage",
              name: "话题管理",
            },
            {
              index: "2-6",
              link: "/yunying/community/quickComment",
              name: "快捷评论",
            },
          ],
        },
        {
          name: "照片",
          index: "5",
          options: [
            {
              index: "5-1",
              link: "/yunying/photo/photoList",
              name: "照片管理",
            },
          ],
        },
        {
          name: "广告位",
          index: "6",
          options: [
            {
              index: "6-1",
              link: "/yunying/bounce/bounceManage",
              name: "弹框管理",
            },
            // {
            //   index: "6-2",
            //   link: "/yunying/banner/bannerManage",
            //   name: "banner管理",
            // },
            // {
            //   index: "6-3",
            //   link: "/yunying/flicker/flickerScreen",
            //   name: "闪屏管理",
            // },
            // {
            //   index: "6-4",
            //   link: "/yunying/runPoint/runPointManage",
            //   name: "跑步点位管理",
            // },
            // {
            //   index: "6-5",
            //   link: "/yunying/icon/iconManage",
            //   name: "入口icon管理",
            // },
            // {
            //   index: "6-6",
            //   link: "/yunying/advert/advertType",
            //   name: "信息流广告",
            // },
            // {
            //   index: "6-7",
            //   link: "/yunying/sdkAdvert/sdkAdvert",
            //   name: "SDK广告管理",
            // },
            // {
            //   index: "6-8",
            //   link: "/yunying/advert/runBtn",
            //   name: "跑步按钮广告",
            // },
            {
              index: "6-9",
              link: "/yunying/advert/HomeDialog",
              name: "校内浮窗管理",
            },
            // {
            //   index: "6-10",
            //   link: "/yunying/HomeTopEntrance",
            //   name: "首页顶部入口",
            // },
            // {
            //   index: "6-11",
            //   link: "/yunying/TopicsTopEntrance",
            //   name: "话题栏首位入口",
            // },
            {
              index: "6-12",
              link: "/yunying/advertising/ad/management",
              name: "广告管理",
            },
            {
              index: "6-16",
              link: "/yunying/advertising/ad/managementNew",
              name: "广告管理新版",
            },
            {
              index: "6-13",
              link: "/yunying/advertising/pingan/cooperation",
              name: "平安合作配置",
            },
            {
              index: "6-14",
              link: "/yunying/advertising/resource/space",
              name: "资源位配置",
            },
            {
              index: "6-15",
              link: "/yunying/advertising/mine/page",
              name: "我的页面配置",
            },
          ],
        },
        {
          name: "活动",
          index: "7",
          options: [
            {
              index: "7-1",
              link: "/yunying/activity/activityManage",
              name: "活动管理",
            },
            {
              index: "7-2",
              link: "/yunying/activity/theme/running",
              name: "主题跑",
            },
            {
              index: "7-3",
              link: "/yunying/activity/questionnaireManage",
              name: "问卷调查",
            },
          ],
        },
        {
          name: "积分",
          index: "8",
          options: [
            {
              index: "8-1",
              link: "/yunying/integration/integration",
              name: "奖品配置",
            },
          ],
        },
        {
          name: "分销管理",
          index: "9",
          options: [
            {
              index: "9-1",
              link: "/yunying/distribut/distribut",
              name: "分销员管理",
            },
            {
              index: "9-2",
              link: "/yunying/distribut/criditCardUser",
              name: "数据统计",
            },
          ],
        },
        {
          name: "用户管理",
          index: "10",
          options: [
            {
              index: "10-1",
              link: "/yunying/user/privilege/role",
              name: "特权角色",
            },
            {
              index: "10-2",
              link: "/yunying/userManagement",
              name: "用户列表",
            },
            // {
            //   index: "10-3",
            //   link: "/yunying/applicationReview",
            //   name: "申请审核",
            // },
            {
              index: "10-3",
              link: "/yunying/userDiyPage",
              name: "个性化组件",
            },
            {
              index: "10-6",
              link: "/yunying/platform/decoration",
              name: "平台装饰",
            },
            {
              index: "10-8",
              link: "/yunying/user/share/template",
              name: "分享模板",
            },
            {
              index: "10-4",
              link: "/yunying/user/experience/card",
              name: "体验卡管理",
            },
            {
              index: "10-5",
              link: "/yunying/user/member/sale",
              name: "会员卡售卖",
            },
            {
              index: "10-7",
              link: "/yunying/user/member/promotion",
              name: "会员卡促销",
            },
          ],
        },
        {
          name: "短信管理",
          index: "11",
          options: [
            {
              index: "11-1",
              link: "/yunying/SMSManage",
              name: "短信管理",
            },
            {
              index: "11-2",
              link: "/yunying/sms/task",
              name: "短信任务",
            },
          ],
        },
        {
          name: "弹幕",
          index: "12",
          options: [
            {
              index: "12-1",
              link: "/yunying/CatalogManagement",
              name: "类目管理",
            },
            {
              index: "12-2",
              link: "/yunying/PublicBulletinManagement",
              name: "公共弹幕管理",
            },
            {
              index: "12-3",
              link: "/yunying/CustomizedBulletinManagement",
              name: "自定义弹幕管理",
            },
          ],
        },
        {
          name: "运动课程",
          index: "13",
          options: [
            {
              index: "13-1",
              link: "/yunying/course/courseManage",
              name: "课程",
            },
            {
              index: "13-2",
              link: "/yunying/course/categoryManage",
              name: "课程分类",
            },
          ],
        },
        {
          name: "文案管理",
          index: "16",
          options: [
            {
              index: "16-1",
              link: "/yunying/copywriting/memberExpireRemind",
              name: "会员临期提醒",
            },
            {
              index: "16-2",
              link: "/yunying/copywriting/runShareCopy",
              name: "跑后分享文案",
            },
          ],
        },
        {
          name: "线上赛",
          index: "14",
          options: [
            {
              index: "14-1",
              link: "/yunying/onlineMatch/matchManage",
              name: "赛事管理",
            },
            {
              index: "14-2",
              link: "/yunying/onlineMatch/signUpManage",
              name: "报名管理",
            },
            {
              index: "14-3",
              link: "/yunying/onlineMatch/matchPrizeManage",
              name: "奖品管理",
            },
          ],
        },
        {
          name: "系统配置",
          index: "15",
          options: [
            {
              index: "15-1",
              link: "/yunying/system/config",
              name: "系统配置",
            },
          ],
        },
      ],
    };
  },
};
</script>



// WEBPACK FOOTER //
// index.vue?2a00fd48